import { FC } from 'react'
import { useIsIssueInProcess } from '@/core/hooks/useIsIssueInProcess'
import { IssueStatus } from '@/ui/components/IssueStatus'
import { Divider } from '@/ui/components/Divider/Divider.styles'
import { HeaderSeverityBadge } from '@ui/drawer/common/HeaderSeverityBadge'
import { BadgesWrapper } from './issueDrawerHeaderConfig.styles'

const BADGE_SEVERITIES: TIssueSeverity[] = [
    'critical',
    'important',
    'moderate',
]

interface IssueDrawerHeaderBadgesProps {
    issue: TIssue
}

const IssueDrawerHeaderBadges: FC<IssueDrawerHeaderBadgesProps> = ({
    issue,
}) => {
    const { isIssueInProcess } = useIsIssueInProcess(issue.id)

    const showSeverity = BADGE_SEVERITIES.includes(issue.severity)
    const showStatus = Boolean(issue.status)

    const renderDivider = () => (
        <Divider vertical height="15px" data-testid="header-badge-divider" />
    )

    return (
        <BadgesWrapper data-testid="issue-drawer-header-badges">
            {(showSeverity || showStatus) && renderDivider()}
            {showSeverity && (
                <HeaderSeverityBadge severity={issue.severity} />
            )}
            {showSeverity && showStatus && renderDivider()}
            {showStatus && (
                <IssueStatus
                    status={issue.status}
                    isInProcess={isIssueInProcess}
                    testId={`issue-drawer-header-status-${issue.status}`}
                />
            )}
        </BadgesWrapper>
    )
}

export default IssueDrawerHeaderBadges
